<div class="container">
    <div class="row">
        <mat-toolbar class="r-toolbar">
            <button mat-icon-button class="example-icon" [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with menu icon">
                <mat-icon>menu</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item [routerLink]="'/admin/events'">
                    <mat-icon>home</mat-icon>
                    <span>Home</span>
                </button>
                <button mat-menu-item [routerLink]="'/admin/events'">
                    <mat-icon>person</mat-icon>
                    <span>People</span>
                </button>
                <button mat-menu-item [routerLink]="'/admin/events'">
                    <mat-icon>groups</mat-icon>
                    <span>Organisations</span>
                </button>
                <button mat-menu-item [routerLink]="'/admin/events'">
                    <mat-icon>view_timeline</mat-icon>
                    <span>Projects</span>
                </button>
                <button mat-menu-item [routerLink]="'/admin/events'">
                    <mat-icon>event</mat-icon>
                    <span>Events</span>
                </button>
                <button mat-menu-item disabled>
                    <mat-icon>settings</mat-icon>
                    <span>Settings</span>
                </button>
            </mat-menu>

            @if (instance_name === 'dev') {
            <div class="header-title">EUFIC Nexus - <span style="color: red">&nbsp; Dev instance</span>  <span class="material-symbols-outlined" style="font-size: xx-large; color: red">
                    experiment </span></div>
            } @else if (instance_name === 'test') {
            <div class="header-title">EUFIC Nexus - <span style="color: red">&nbsp; Test instance</span> <span class="material-symbols-outlined" style="font-size: xx-large; color: red">
                    experiment
                </span></div>
            } @else if (instance_name === 'live') {
            <div class="header-title">EUFIC Nexus</div>
            } @else {
            <div class="header-title">EUFIC Nexus - Are you on Mars?</div>
            }
            <span class="example-spacer"></span>


            @if (signedIn) {
            <span>{{ username }}</span>
            @if (userrole.includes('super')) {
            <span class="material-symbols-sharp" style="color: var(--nexus-red)"
                title="{{userRoles}}">workspace_premium</span>
            } @else if (userrole.includes(ROLES.ADMIN)) {
            <span class="material-symbols-outlined" style="color: var(--nexus-dark-blue)"
                title="{{userRoles}}">workspace_premium</span>
            } @else if (userrole.includes(ROLES.ADVANCED)) {
            <span class="material-symbols-outlined" style="color: var(--nexus-dark-blue)"
                title="{{userRoles}}">license</span>
            }
            <button mat-icon-button (click)="signOut()">
                <mat-icon>logout</mat-icon>
            </button>
            } @else {
            <button mat-icon-button (click)="login()">
                <mat-icon>login</mat-icon>
            </button>
            }
        </mat-toolbar>
    </div>
</div>